<template>
  <div class="hello">
    <my-header :activeIndex="2"/>
    <div class="main">
      <img src="../../assets/gift/banner.jpg" style="width:100%"/>
      <img src="../../assets/gift/center.jpg" style="width:100%"/>
    </div>
    <my-footer/>
    <my-top/>
  </div>
</template>
<script>
import MyFooter from "./MyFooter.vue";
import MyHeader from "./MyHeader.vue";
import MyTop from "./MyTop.vue";
export default {
  name: 'about',
  components: {
    "my-footer": MyFooter,
    "my-header": MyHeader,
    "my-top": MyTop,
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped>
.hello{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/gift.vue